import React, { useEffect, useState } from "react";
import useCosmosCollections from "../../../hooks/use-cosmos-collections";
import useRecordsData from "../../../hooks/use-records-data";
import { getQueryOptions } from "./hooks/query-options";
import useWidgetSettingsByKey from "../../../hooks/use-widget-settings-by-key";
import { getUsersDetails } from "../data-helpers";
import useCosmosFields from "../../../hooks/use-cosmos-fields";
import useDateRanges from "./hooks/use-date-ranges";
import { useWorkAnniversaryStore } from "../../../stores/use-work-anniversary-store";
import WorkAnniversary from "../widget/WorkAnniversary";

export const WIDGET_DATA = {
  id: "work-aniversary-main",
  name: "Work Anniversary",
};

function WorkAnniversaryDataBuilder({ mode }) {
  const [users, setUsers] = useState([]);
  const [records, setRecords] = useState([]);

  const { data } = useWorkAnniversaryStore((state) => ({
    data: state.data,
  }));

  const { titleFieldId } = data;

  const { collections } = useCosmosCollections();
  const { fields } = useCosmosFields();

  const { workAnniversaryRange, startOrEndOfCurrentYear } = useDateRanges();

  const { isWidgetSettingsLoading, widgetSettingsData } =
    useWidgetSettingsByKey({
      enabled: true,
      key: WIDGET_DATA.id,
      widgetId: WIDGET_DATA.id,
    });

  const {
    exists = false,
    widget: { selectedField: selectedDatabaseFieldId = "" } = {},
  } = widgetSettingsData;

  const selectedCollections = collections.filter((clc) =>
    data.collectionId.find((collId) => String(collId) === String(clc.value))
  );

  const filters = selectedCollections.map((clc) => clc.data.filters).flat();

  const { isRecordsLoading, recordsData } = useRecordsData({
    isEnabled: !!selectedDatabaseFieldId && !!workAnniversaryRange?.start,
    options: getQueryOptions({
      databaseFieldId: selectedDatabaseFieldId,
      workAnniversaryRange,
      startOrEndOfCurrentYear,
      collectionFilters: filters,
    }),
  });

  useEffect(() => {
    if (!records?.length) {
      return setUsers([]);
    }

    const fetchUsersDetails = async () => {
      try {
        const users = await getUsersDetails({
          records,
          databaseFieldId: selectedDatabaseFieldId,
          fields: fields.map(({ fieldProps }) => fieldProps) || [],
          titleFieldId: titleFieldId,
        });
        setUsers(users);
      } catch (error) {
        console.log("Can not get user with details.");
        setUsers([]);
      }
    };

    fetchUsersDetails();
  }, [records, fields, titleFieldId, selectedDatabaseFieldId]);

  useEffect(() => {
    if (
      selectedDatabaseFieldId &&
      !isRecordsLoading &&
      !isWidgetSettingsLoading
    ) {
      setRecords([...(recordsData || [])]);
    }
  }, [
    recordsData,
    isRecordsLoading,
    isWidgetSettingsLoading,
    selectedDatabaseFieldId,
  ]);

  const cosmosIsNotSetup =
    (!exists || !selectedDatabaseFieldId.length) && !isWidgetSettingsLoading;

  const noUsers = !users.length && !records.length && !isRecordsLoading;

  return (
    <WorkAnniversary
      users={users}
      loading={isRecordsLoading || isWidgetSettingsLoading}
      cosmosIsNotSetup={cosmosIsNotSetup}
      noUsers={noUsers}
      mode={mode}
    />
  );
}

export default WorkAnniversaryDataBuilder;
